<router-outlet></router-outlet>
<ng-template #confirmModal role="document" let-modal>
    <h5 mat-dialog-title class="modal_title flex">
       {{"EMAIL_WARMUP.WARMING_UP" | translate}}
    </h5>
    <mat-dialog-content class="modal_body pb-0">
        <p class="text-[#0b0d13] font-normal leading-5 text-md mb-4"> Upon activating the warm-up feature, your account
           {{"EMAIL_WARMUP.WILL_INITIATE_THE_PROCESS_OF_SENDING_AND_RECEIVING_EMAILS" | translate}}
        </p>

        <p class="text-[#0b0d13] font-normal leading-5 text-md">
            <mat-icon svgIcon="mat_outline:warning" class="text-yellow-500 icon-size-4 align-middle pt-1"></mat-icon>
            <span>
               {{"EMAIL_WARMUP.IMPACT_THE_OVERALL_QUALITY_OF_THE_POOL" | translate}}
            </span>
        </p>
        <mat-checkbox class="campaign-checkBox mt-3 -ml-2.5" [(ngModel)]="ischecked"
                >{{"EMAIL_WARMUP.YES_I_UNDERSTAND" | translate}}</mat-checkbox>
    </mat-dialog-content>
    <mat-dialog-actions align="start" class="form_action mt-[2px]">
        <btn-loading type="submit" color="primary" (click)="acceptPolicy()" [ngClass]="{'pointer-events-none opacity-60': !ischecked}"
            btnClass="text-md text-custom font-medium leading-[14px] min-h-[34px] max-h-[34px] rounded">
            {{"EMAIL_WARMUP.CONTINUE" | translate}}
        </btn-loading>
    </mat-dialog-actions>
</ng-template>